import React, { PureComponent } from 'react';

import Steps from '@mos-front-components/public/es/components/Steps';
import Collapse, {
  Panel
} from '@mos-front-components/public/es/components/Collapse';

import ImportantInfo from '../ImportantInfo/ImportantInfo';
import rules from './private/rules.pdf';

import './Instruction.pcss';

// typograf-enable
const steps = [
  {
    title: 'Подготовьте данные в личном кабинете',
    content: (
      <React.Fragment>
        <p className="StartPage-step__text">
          <a
            className="Link"
            href="https://oauth20.mos.ru/selfservice/registration/openregister.do"
          >
            {' '}
            Зарегистрируйтесь
          </a>{' '}
          на сайте mos.ru, если вы ещё этого не сделали.
        </p>
        <p className="StartPage-step__text">
          Введите в
          <a
            className="Link"
            href="https://my.mos.ru/my/#/"
            rel="noopener noreferrer"
            target="_blank"
          >
            {' '}
            Личном кабинете
          </a>{' '}
          ваш СНИЛС для верификации аккаунта.
        </p>
        <p className="StartPage-step__text">
          Сохраните в Профиле данные паспорта.
        </p>
      </React.Fragment>
    )
  },
  {
    title: 'Подайте апелляцию в электронном виде',
    content: (
      <React.Fragment>
        <p className="StartPage-step__text">
          Вам будет предоставлена возможность скачать скан-копии бланков
          ответов/прослушать аудиозаписи устных ответов, листа распознавания
          бланка, который используется для внесения ответов на задания с кратким
          ответом.
        </p>
        <p className="StartPage-step__text">
          Подтвердите, что предоставленная работа является вашей.
        </p>
        <p className="StartPage-step__text">
          Если представленные материалы для просмотра (прослушивания) не
          принадлежат вам, то вы сможете подать заявление о несоответствии
          бланков ответов/аудиозаписей устных ответов.
        </p>
        <p className="StartPage-step__text">
          Если же представленные материалы для просмотра (прослушивания)
          принадлежат вам, то вы сможете подать апелляцию на результаты ГИА.
        </p>
        <p className="StartPage-step__text">
          Отметьте те задания, с оцениванием которых вы не согласны, и обоснуйте
          свое мнение.
        </p>
      </React.Fragment>
    )
  },
  {
    title: 'Дождитесь результатов рассмотрения вашей апелляции',
    content: (
      <React.Fragment>
        <p className="StartPage-step__text">
          Регистрация апелляции занимает не более 3 часов.
        </p>
        <p className="StartPage-step__text">
          В течение 2 рабочих дней в{' '}
          <a
            className="Link"
            href="https://my.mos.ru/my/#/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Личный кабинет{' '}
          </a>{' '}
          на Портале будет направлено экспертное заключение. В случае если у вас
          останутся вопросы после ознакомления с экспертным заключением, вы
          можете принять участие в онлайн-чате. Ссылка для участия в онлайн-чате
          будет направлена вместе с экспертным заключением. Изучите внимательно
          инструкцию о том, как проводится онлайн-чат.
        </p>
        <p className="StartPage-step__text">
          Также Вам будет направлена ссылка на трансляцию заседания
          апелляционной комиссии, во время которой будет оглашено решение по
          итогам рассмотрения апелляции по вашей работе.
        </p>
        <p className="StartPage-step__text">
          В течение 4 рабочих дней в{' '}
          <a className="Link" href="https://my.mos.ru/my/#/">
            Личный кабинет{' '}
          </a>{' '}
          на Портале будет направлено решение апелляционной комиссии в
          электронном виде.
        </p>
      </React.Fragment>
    )
  },
  {
    title: 'Дополнительные сведения',
    content: (
      <React.Fragment>
        <p className="StartPage-step__text">
          Заявление на апелляцию или заявление о несоответствии
          бланков/аудиозаписей устных ответов может быть отозвано пользователем
          в течение 24 часов после его регистрации. После отзыва заявления и в
          случае, если сроки подачи апелляций еще не истекли, вы сможете подать
          нужное вам заявление.
        </p>
      </React.Fragment>
    )
  }
];

class Instruction extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: []
    };

    this.togglePanel = this.togglePanel.bind(this);
  }

  togglePanel(activeKey) {
    this.setState({
      activeKey
    });
  }

  render() {
    const { activeKey } = this.state;

    return (
      <div className="StartPage">
        <div className="StartPage-content">
          <div className="StartPage__title">Как это работает</div>
          <div className="col-md-8">
            <Steps className="InstructionStep">
              <React.Fragment>
                {steps.map((step, index) => (
                  <Steps.Step
                    step={index + 1}
                    key={step.title}
                    title={step.title}
                    completed={step.completed}
                    withSend={false}
                    collapsible={false}
                  >
                    {step.content}
                  </Steps.Step>
                ))}
              </React.Fragment>
            </Steps>
          </div>
        </div>

        <div className="StartPage-content StartPage-content--Bottom">
          <div className="StartPage__title">Оформление услуги на сайте</div>
          <div className="StartPage-info__content">
            <div className="StartPage-block col-md-8">
              <h3 className="StartPage-block__title">
                Подача апелляции о несогласии с выставленными баллами
                государственной итоговой аттестации (ЕГЭ, ОГЭ, ГВЭ)
              </h3>
              <div className="StartPage-block__info">
                <div className="StartPage-block__text">
                  <div className="StartPage-faq-content">
                    Данная услуга позволяет подать апелляцию на результаты ГИА.
                    Апелляция может быть подана участником по достижении им 14
                    лет или родителем (законным представителем) участника.
                  </div>
                </div>
              </div>
              <Collapse
                className="CollapseService"
                activeKey={activeKey}
                defaultActiveKey="1"
                onChange={this.togglePanel}
              >
                <Panel
                  key="1"
                  header="Кто может обратиться за услугой"
                  headerClass="faq-StartPage-faq-content"
                >
                  <div className="StartPage-faq-content">
                    Физическое лицо (участник ГИА, достигший 14 лет) или
                    родитель (законный представитель) участника.
                  </div>
                </Panel>

                <Panel
                  key="2"
                  header="Стоимость услуги и порядок оплаты"
                  headerClass="faq-label"
                >
                  <div className="StartPage-faq-content">Бесплатно</div>
                </Panel>

                <Panel
                  key="3"
                  header="Перечень необходимых сведений"
                  headerClass="faq-label"
                >
                  <div className="StartPage-faq-content">
                    <ul className="List">
                      <li>Документ, удостоверяющий личность</li>
                      <li>СНИЛС</li>
                      <li>Уведомление с кодом регистрации</li>
                    </ul>
                  </div>
                </Panel>
                <Panel
                  key="4"
                  header="Сроки предоставления услуги"
                  headerClass="faq-label"
                >
                  <div className="faq-content">
                    4 рабочих дня с момента подачи заявления
                  </div>
                </Panel>
                <Panel
                  key="5"
                  header="Результат оказания услуги"
                  headerClass="faq-label"
                >
                  <div className="faq-content">
                    Решение апелляционной комиссии об удовлетворении или
                    отклонении апелляции
                  </div>
                </Panel>
              </Collapse>
            </div>
            <div className="StartPage-block StartPage-block_right col-md-4">
              <h3 className="StartPage-block__title">Ведомство</h3>
              <div className="StartPage-block__text">
                <a
                  href="/dogm/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="Link StartPage-step__link_block"
                >
                  Департамент образования и науки города Москвы
                </a>
              </div>
              <h3 className="StartPage-block__title">Информация</h3>
              <div className="StartPage-block__text">
                <a
                  href={rules}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="Link StartPage-step__link_block"
                >
                  Правила предоставления электронного сервиса
                </a>
                <a
                  href="/donm/documents/"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="Link StartPage-step__link_block"
                >
                  Нормативные акты
                </a>
              </div>
            </div>
          </div>
        </div>

        <ImportantInfo />
      </div>
    );
  }
}

export default Instruction;
